import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const checkTrialExtensionEligibility = createAsyncThunk(
  'checkTrialExtensionEligibility',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/extend_trials/check_eligibility',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
